import api from "./axios.service";
import { getQueryStringFromObject } from "./common.service";
const axios = api;

async function getReleases(query = {}) {
    try {
        let queryString = await getQueryStringFromObject(query);
        if (queryString) {
            queryString = '?' + queryString;
        } else {
            queryString = '';
        }
        let response = await axios.get('/releases' + queryString);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}


async function insertRelease(releaseData) {
    try {
        let response = await axios.post('/releases', releaseData);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export {
    getReleases,
    insertRelease
}
